import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";

const settings = {
  dots: false,
  slidesToShow: 2,
  infinite: true,
  autoplay: true,
  slidesToScroll: 1,
  pauseOnHover: false,
  arrows: true,
  cssEase: "ease",
  autoplaySpeed: 5000,
  speed: 2000,
  responsive: [
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 2,
      },
    },

    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
      },
    },

    {
      breakpoint: 599,
      settings: {
        slidesToShow: 1,
      },
    },],
};

export default function OnDemandChoose({ data }) {
  const [isSlider, setIsSlider] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;

    const handleResize = () => {
      setIsSlider(window.innerWidth < 992);
    };

    handleResize(); // ✅ set initial value

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  if (!data) {
    return null;
  }
  return (
    <>
      <section className="bla-features-area">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10">
              <h3 className="heading center-heading">{data.titlePart1} <span className="gradiant-color">{data.titlePart2}</span> {data.titlePart3}</h3>
              <p className="sub-heading">{data.description}</p>
            </div>

            {!isSlider ?
              (data.boxes.map((item, index) => (
                <div className="col-lg-4 wow animate__animated animate__bounceIn" key={index}>
                  <div className="bla-feature-box ondemand-choose-box">
                    <span><img loading="lazy" src={item.image} alt="icon" className="img-responsive" /></span>
                    <label>{item.heading}</label>
                    <p>{item.description}</p>
                  </div>
                </div>
              ))) :
              (
                <div className="col-lg-12">
                  <Slider className="bla-feature-slide" {...settings}>
                    {data.boxes.map((item, index) => (
                      <div className="bla-feature-box" key={index}>
                        <span><img loading="lazy" src={item.image} alt="icon" className="img-responsive" /></span>
                        <label>{item.heading}</label>
                        <p>{item.description}</p>
                      </div>))}
                  </Slider>
                </div>)
            }
          </div>
        </div>
      </section >
    </>
  )
}
